import React from 'react';
import { Box } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { Renewal } from '../renewals.types';

import RenewalSetupTopbar from './RenewalSetupTopbar';

interface Props {
  renewalSetupData?: Renewal;
  children: React.ReactNode;
}

const RenewalSetupWrapper: React.FC<Props> = ({
  renewalSetupData,
  children,
}) => {
  return (
    <Box
      width="100%"
      data-testid="renewal-setup-wrapper"
      justify="between"
      height="fit-content"
      margin={{ bottom: 'xxl' }}
    >
      <Box>
        <RenewalSetupTopbar
          renewalSetupData={renewalSetupData}
        />
        <Box width={theme.defaultMinContentWidth} direction="row" alignSelf="center" justify="between" margin="l">
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default RenewalSetupWrapper;
